import { Base } from '@studiometa/js-toolkit';
import PanelStories from './PanelStories.js';

/**
 * @typedef {{}} StoriesProps
 */

/**
 * Stories Stories.
 * @augments {Base<StoriesProps>}
 */
export default class Stories extends Base {
  currentIndex = 0;

  alreayOpen = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Stories',
    refs: ['container', 'btn[]'],
    components: {
      PanelStories,
    },
    options: {
      destinationId: {
        default: '0',
        type: String,
      },
    },
  };

  /**
   * onBtnClick
   * @param {object} props
   * @param {number} props.index
   */
  onBtnClick({ index }) {
    this.$children.PanelStories[0].openPanel(index);
    this.alreayOpen = true;
  }
}
